<template>
  <div class="item-style">
    <span class="flag-icon" :class="[ getFlagClass() ]"></span>
    <span class="cx-search-icon cx-clickable-icon" 
          @click="handleClick">
      <i class="fas fa-search mx-2"></i>
    </span>
    <span class="mx-2">{{ this.country.CountryName }}</span>
  </div>
</template>

<script>
export default {
  beforeMount() {
    this.country = this.params.context.getCountry(this.params.value);
  },

  methods: {
    getFlagClass() {
      return `flag-icon-${this.country.CountryId.toLowerCase()}`;
    },

    handleClick(event) {
      this.params.context.onClickCountry(this.country.CountryId.toLowerCase());
    }
  }
}
</script>

<style >
  .item-style  {
    line-height: 1.5rem!important;
    padding-top: 10px!important;
    padding-bottom: 10px!important;
    text-align: left; 
    text-align: -webkit-left;
    font-weight: 600;
    font-size: 15px;
  }
  
  .item-style div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
